// import ZJApp from '../../../api'
import ZJApi from './api.js'
// import ZJConfig from '../../config'
import utils from '../../utils'
 
const info = {
    service: 'AlarmService',
    controller: 'AlertInfo'
};

const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'GetItemById',
    'GetAlertItemPagingList',
    'GetItemPagingList' //求助的列表请求
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const EarlymsgApi = ZJApi.defineNewApi('EarlymsgApi', factory);

export default EarlymsgApi;